/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPolicyOntologyMigration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPolicyOntologyMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPolicyOntologyMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPolicyOntologyMigration>): BackgroundJobPayloadForPolicyOntologyMigration {
        let obj = Object.assign(new BackgroundJobPayloadForPolicyOntologyMigration(), model);
        BackgroundJobPayloadForPolicyOntologyMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPolicyOntologyMigration>): BackgroundJobPayloadForPolicyOntologyMigration {
        if (!model) return null;
        return BackgroundJobPayloadForPolicyOntologyMigration.newInstance(<BackgroundJobPayloadForPolicyOntologyMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPolicyOntologyMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPolicyOntologyMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPolicyOntologyMigration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPolicyOntologyMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
